
import { createRouter, createWebHashHistory } from 'vue-router';

import { useAuth } from 'src/composables/auth';


function passRouteToProps(route){
	return {
		queryParams: route.query,
		fieldName: route.params.fieldName, 
		fieldValue: route.params.fieldValue
	}
}


let routes = [
	//Dashboard routes


//authtable routes
			{
				path: '/authtable/:fieldName?/:fieldValue?',
				name: 'authtablelist',
				component: () => import('./pages/authtable/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/authtable/view/:id', 
				name: 'authtableview', 
				component: () => import('./pages/authtable/view.vue'), 
				props: true
			},
		
			{ 
				path: '/account/edit', 
				name: 'authtableaccountedit', 
				component: () => import('./pages/account/accountedit.vue'), 
				props: true
			},
	
			{ 
				path: '/account', 
				name: 'authtableaccountview', 
				component: () => import('./pages/account/accountview.vue'), 
				props: true
			},
	
			{ 
				path: '/authtable/add', 
				name: 'authtableadd', 
				component: () => import('./pages/authtable/add.vue'), 
				props: true
			},
	
			{ 
				path: '/authtable/edit/:id', 
				name: 'authtableedit', 
				component: () => import('./pages/authtable/edit.vue'), 
				props: true
			},
		
			{
				path: '/authtable/pruebaaut/:fieldName?/:fieldValue?',
				name: 'authtablepruebaaut',
				component: () => import('./pages/authtable/pruebaaut.vue'), 
				props: route => passRouteToProps(route)
			},
	

//datagas routes

//devices routes
			{
				path: '/devices/:fieldName?/:fieldValue?',
				name: 'deviceslist',
				component: () => import('./pages/devices/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/devices/view/:id', 
				name: 'devicesview', 
				component: () => import('./pages/devices/view.vue'), 
				props: true
			},
		
			{ 
				path: '/devices/add', 
				name: 'devicesadd', 
				component: () => import('./pages/devices/add.vue'), 
				props: true
			},
	
			{ 
				path: '/devices/edit/:id', 
				name: 'devicesedit', 
				component: () => import('./pages/devices/edit.vue'), 
				props: true
			},
		
			{
				path: '/devices/nav_dashboard/:fieldName?/:fieldValue?',
				name: 'devicesnav_dashboard',
				component: () => import('./pages/devices/nav_dashboard.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/devices/dashboard/:id', 
				name: 'devicesdashboard', 
				component: () => import('./pages/devices/dashboard.vue'), 
				props: true
			},
		
			{
				path: '/devices/nav_dashboard_gas/:fieldName?/:fieldValue?',
				name: 'devicesnav_dashboard_gas',
				component: () => import('./pages/devices/nav_dashboard_gas.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/devices/dashboard_energia/:id', 
				name: 'devicesdashboard_energia', 
				component: () => import('./pages/devices/dashboard_energia.vue'), 
				props: true
			},
		

//permissions routes

//phasea routes

//phaseb routes

//phasec routes

//roles routes

//type routes

			{ 
				path: '/componentes_guardados', 
				name: 'componentes_guardados', 
				component: () => import('././pages/custom/componentes_guardados.vue'), 
				props: true
			},
	
	
	
	
	
	{ 
		path:  '/error/forbidden', 
		name: 'forbidden', 
		component: () => import('./pages/errors/forbidden.vue'),
		props: true
	},
	{ 
		path: '/error/notfound', 
		name: 'notfound',
		component: () => import('./pages/errors/pagenotfound.vue'),
		props: true
	},
	{
		path: '/:catchAll(.*)', 
		component: () => import('./pages/errors/pagenotfound.vue')
	}
];

export default () => {
	
const auth = useAuth();

	
	const user = auth.user;
	if(user){
		routes.push({ path: '/', alias: '/home', name: 'home', component: () => import(`./pages/home/home.vue`) });
	}
	else{
		routes.push({ path: '/', alias: '/index', name: 'index', component: () => import('./pages/index/index.vue') });
	}

	const router = createRouter({
		history: createWebHashHistory(),
		routes,
		scrollBehavior(to, from, savedPostion){
			if(savedPostion) return savedPostion;
			return { top:0 }
		}
	});
	
	router.beforeEach((to, from, next) => {
		const user = auth.user;
		let path = to.path;
		let authRequired = auth.pageRequiredAuth(path);
		if (authRequired) {
			if(!user){
				return next({ path: '/',  query: { nexturl: to.fullPath } });
			}
			//authorize user
			if (!auth.canView(path)) {
				return next({path: "/error/forbidden"});
			}
		}

		if(user && to.name == "index"){
			//already logged in, show home when try to access index page
			return next({ path: "/home"});
		}

		//navigate to redirect url if available
		if(to.name == "home" && to.query.nexturl){
			return next({ path: to.query.nexturl});
		}

 		//close dialog from previous page
		//store.closeDialogs('app/closeDialogs');
		
		next();
	});

	return router;
}
